import { MMKV } from 'react-native-mmkv'

/**
 * Unencrypted MMKV instance for non-sensitive user preferences.
 * Theme choice is not sensitive data — no encryption needed.
 * Separate instance from the encrypted auth storage.
 */
let themeStorage: MMKV
try {
  themeStorage = new MMKV({ id: 'tago-theme-prefs' })
} catch {
  // SSR: MMKV constructor fails during static rendering
  themeStorage = { getString: () => undefined, set: () => {}, delete: () => {} } as unknown as MMKV
}

const THEME_MODE_KEY = 'theme_mode'

export const ThemePrefs = {
  getMode(): 'light' | 'dark' {
    try {
      const stored = themeStorage.getString(THEME_MODE_KEY)
      if (stored === 'light' || stored === 'dark') return stored
      if (stored === 'system') {
        themeStorage.set(THEME_MODE_KEY, 'light')
        return 'light'
      }
    } catch {
      // SSR: MMKV not available during Expo Router static rendering
    }
    return 'light'
  },

  setMode(mode: 'light' | 'dark'): void {
    try {
      themeStorage.set(THEME_MODE_KEY, mode)
    } catch {
      // SSR: MMKV not available during static rendering
    }
  },

  clearMode(): void {
    try {
      themeStorage.delete(THEME_MODE_KEY)
    } catch {
      // SSR: MMKV not available during static rendering
    }
  },
}
